const Dialogs = {};
(() => {
	const ALLOWED_PROMPT_TYPES = ['text', 'radio', 'checkbox', 'select', 'password', 'number'];
	const DIALOG_DEFAULTS = {
		style: 'default',//error|warning|info
		dialogType: 'alert',
		cancelText: 'Cancel',
		confirmText: 'Ok',
		confirmButtonClass: '',
		cancelButtonClass: '',
		allowCancel: true,
		promptType: 'text',
		promptChoices: null,
		promptLabel: '',
		promptPlaceholder: '',
		promptValue: '',
		title: '',
		content: '',
		image: false,
		onConfirm: null,
		onCancel: null,
	};

	const __extend = (...arguments) => {

		// Variables
		let extended = {};
		let deep = false;
		let i = 0;

		// Check if a deep merge
		if (typeof (arguments[0]) === 'boolean') {
			deep = arguments[0];
			i++;
		}

		// Merge the object into the extended object
		let merge = function (obj) {
			for (let prop in obj) {
				if (obj.hasOwnProperty(prop)) {
					if (deep && Object.prototype.toString.call(obj[prop]) === '[object Object]') {
						// If we're doing a deep merge and the property is an object
						extended[prop] = __extend(true, extended[prop], obj[prop]);
					} else {
						// Otherwise, do a regular merge
						extended[prop] = obj[prop];
					}
				}
			}
		};

		// Loop through each object and conduct a merge
		for (; i < arguments.length; i++) {
			merge(arguments[i]);
		}

		return extended;

	};

	_getPromptValue = (promptId, options) => {
		let val = undefined;
		let $checked;
		if ( options.dialogType === 'prompt' ) {
			if ( options.promptType === 'radio' || options.promptType === 'checkbox' ) {
				const values = [];
				document.querySelectorAll(`input[name="${promptId}_input"]:checked`).forEach($input => {
					values.push( $input.value );
				});
				if ( values.length ) {
					val = ( values.length > 1 ) ? values : values[0];
				}
			}
			else {
				val = document.getElementById(`${promptId}_input`).value;
			}
		}
		return val;
	};

	const __showDialog = (options) => {
		let _options = structuredClone(DIALOG_DEFAULTS);
		let allOptions = (typeof options === "object") ? __extend(true, _options, options) : _options;
		if ( allOptions.dialogType !== 'alert' && allOptions.dialogType !== 'confirm' && allOptions.dialogType !== 'prompt' ) {
			allOptions.dialogType = DIALOG_DEFAULTS.dialogType;
		}
		if ( allOptions.dialogType === 'alert' ) {
			allOptions.allowCancel = false;
		}
		if ( allOptions.promptChoices && (typeof allOptions.promptChoices !== 'object' || typeof allOptions.promptChoices.forEach !== 'function') ) {
			allOptions.promptChoices = DIALOG_DEFAULTS.promptChoices;
		}
		if ( !allOptions.promptType || ALLOWED_PROMPT_TYPES.indexOf(allOptions.promptType) === -1 ) {
			allOptions.promptType = DIALOG_DEFAULTS.promptType;
		}

		let dialogCount = document.querySelectorAll('.dialog').length;
		let dialogId = `dialog_${dialogCount}`;

		let baseZindex = 999900;

		let dialogBg = document.createElement('div');
		dialogBg.classList.add('dialog-bg');
		dialogBg.dataset.for = dialogId;
		dialogBg.style.zIndex = `${baseZindex + dialogCount}`;

		let cancelButton = ( allOptions.allowCancel ) ? `<button type="button" class="dialog-cancel ${allOptions.cancelButtonClass}">${allOptions.cancelText}</button>` : ``;

		let promptLabel = ( allOptions.dialogType === 'prompt' && allOptions.promptLabel ) ? `<label for="${dialogId}_input" class="prompt-input-label">${allOptions.promptLabel}</label>` : ``;

		let promptInput = '';
		if ( allOptions.promptType === 'checkbox' || allOptions.promptType === 'radio' ) {
			promptInput = `<fieldset class="prompt-choices"><legend>${allOptions.promptLabel}</legend>`;
			if ( allOptions.promptChoices ) {
				allOptions.promptChoices.forEach((choice, i) => {
					const checked = ( allOptions.promptValue && choice.value === allOptions.promptValue ) ? 'checked' : '';
					promptInput += `<div class="prompt-choice"><input id="${dialogId}_input_${i}" type="${allOptions.promptType}" name="${dialogId}_input" class="prompt-${allOptions.promptType}" value="${choice.value}" ${checked} /><label for="${dialogId}_input_${i}">${choice.text}</label> </div>`;
				});
			}
			promptInput += `</fieldset>`;
		}
		else if ( allOptions.promptType === 'select' ) {
			promptInput = `<select id="${dialogId}_input" name="${dialogId}_input" class="prompt-select">`;
			if ( allOptions.promptPlaceholder ) {
				promptInput += `<option value="">${allOptions.promptPlaceholder}</option>`;
			}
			if ( allOptions.promptChoices ) {
				allOptions.promptChoices.forEach(choice => {
					const selected = ( allOptions.promptValue && choice.value === allOptions.promptValue ) ? 'selected' : '';
					promptInput += `<option value="${choice.value}" ${selected}>${choice.text}</option>`;
				});
			}
			promptInput += `</select>`;
		}
		else {
			promptInput = `<input type="${allOptions.promptType}" id="${dialogId}_input" class="prompt-input" value="${allOptions.promptValue}" placeholder="${allOptions.promptPlaceholder}">`;
		}
		let promptInputWrap = ( allOptions.dialogType === 'prompt' ) ? `<div class="prompt-input-wrap">${promptLabel}${promptInput}</div>` : ``;

		let dialog = document.createElement('div');
		dialog.id = dialogId;
		dialog.classList.add('dialog', `dialog--${allOptions.dialogType}`);
		dialog.innerHTML = `<div class="dialog-header">${allOptions.title}</div><div class="dialog-body"><div class="dialog-content">${allOptions.content}</div>${promptInputWrap}</div><div class="dialog-footer">${cancelButton}<button type="button" class="dialog-confirm ${allOptions.confirmButtonClass}">${allOptions.confirmText}</button></div>`;
		dialog.style.zIndex = `${baseZindex + dialogCount + 1}`;

		if ( allOptions.style && allOptions.style !== 'default' ) {
			dialog.classList.add(`dialog-style--${allOptions.style}`);
		}

		document.body.append(dialogBg);
		document.body.append(dialog);
		setTimeout(() => {

			dialogBg.classList.add('active');
			dialog.classList.add('active');

		}, 10);

		dialog.querySelector('.dialog-confirm').addEventListener('click', (e) => {
			e.preventDefault();
			let thisId =  e.currentTarget.closest('.dialog').id;
			if ( typeof allOptions.onConfirm === 'function' ) {
				let val = _getPromptValue(thisId, allOptions);
				allOptions.onConfirm(val);
			}
			Dialogs.close( thisId );
		});

		if ( allOptions.allowCancel ) {
			dialog.querySelector('.dialog-cancel').addEventListener('click', (e) => {
				e.preventDefault();
				let thisId =  e.currentTarget.closest('.dialog').id;
				if ( typeof allOptions.onCancel === 'function' ) {
					let val = _getPromptValue(thisId, allOptions);
					allOptions.onCancel(val);
				}
				Dialogs.close( e.currentTarget.closest('.dialog').id );
			});
		}
	};


	Dialogs.close = (dialogId) => {
		let dialogs = dialogId ? document.querySelectorAll(`#${dialogId}`) : document.querySelectorAll('.dialog');
		if ( dialogs && dialogs.length ) {
			dialogs.forEach(dialog => {
				dialog.classList.remove('active');
				setTimeout(() => {
					dialog.remove();
				}, 300);
			});
		}
		let dialogBgs = dialogId ? document.querySelectorAll(`.dialog-bg[data-for="${dialogId}"]`) : document.querySelectorAll('.dialog-bg');
		if ( dialogBgs && dialogBgs.length ) {
			dialogBgs.forEach(dialogBg => {
				dialogBg.classList.remove('active');
				setTimeout(() => {
					dialogBg.remove();
				}, 300);
			});
		}
	};

	Dialogs.prompt = (options) => {
		let _options = structuredClone(DIALOG_DEFAULTS);
		if (typeof options !== "object") {
			options = {};
		}
		options.dialogType = 'prompt';
		let allOptions = (typeof options === "object") ? __extend(true, _options, options) : _options;
		__showDialog(allOptions);
	};

	Dialogs.confirm = (options) => {
		let _options = structuredClone(DIALOG_DEFAULTS);
		if (typeof options !== "object") {
			options = {};
		}
		options.dialogType = 'confirm';
		let allOptions = (typeof options === "object") ? __extend(true, _options, options) : _options;
		__showDialog(allOptions);
	};

	Dialogs.alert = (options) => {
		let _options = structuredClone(DIALOG_DEFAULTS);
		if (typeof options !== "object") {
			options = {};
		}
		options.dialogType = 'alert';
		let allOptions = (typeof options === "object") ? __extend(true, _options, options) : _options;
		__showDialog(allOptions);
	};

})();